// extracted by mini-css-extract-plugin
export default {"swapDuration":"1000ms","wrapperClass":"joxf0lfMlLTC_8e5Zg59"};